import { useRouteMatch } from 'react-router'

export const useCustomerId = () => {
  const match = useRouteMatch<{ id: string }>()
  return Number(match.params.id)
}
